import { useRef } from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  "@keyframes fadein": {
    from: { opacity: 0.1 },
    to: { opacity: 1 },
  },
  popup: {
    position: "absolute",
    display: "flex",
    "pointer-events": "auto",
    animationName: "$fadein",
    animationDuration: "0.5s",
  },
  container: {
    position: "relative",
  },
  "@keyframes slide": {
    from: { maxHeight: 40 },
    to: { maxHeight: 150 },
  },
  cardsContainer: {
    position: "absolute",
    right: -200,
    top: 50,
    display: "flex",
    maxHeight: 40,
    overflow: "hidden",
    animationName: "$slide",
    animationDuration: "0.6s",
    "animation-delay": "1s",
    "animation-fill-mode": "forwards",
  },
  video: {
    height: 800,
  },
  card: {
    background: "#002134aa",
    color: "white",
    padding: [6, 20],
    "box-sizing": "border-box",
    marginBottom: 1,
  },
  title: {
    extend: "card",
    background: "#002134",
    minHeight: 40,
    fontSize: 20,
  },
  description: {
    extend: "card",
    fontSize: 13,
    textAlign: "center",
  },
  contactAgent: {
    extend: "card",
    color: "white",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
    background: "#ff7209",
    "&:hover": {},
  },
  close: {
    marginLeft: 1,
    width: 40,
    height: 40,
    background: "#002134",
    "margin-right": 1,
    flexShrink: 0,
    flexGrow: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    "pointer-events": "auto",
    "& span": {
      color: "white",
      margin: 0,
      fontSize: 30,
      transform: "rotate(45deg)",
      userSelect: "none",
    },
  },
});

const VPRPopup = ({ style: { top, left }, closePopup }) => {
  const classes = useStyles();
  const ref = useRef();

  const setVideoPlaying = playing => {
    if (!ref.current) {
      return;
    }
    if (playing) {
      ref.current.play();
    } else {
      ref.current.pause();
    }
  };

  const toggleVideoPlaying = () => {
    if (!ref.current) {
      return;
    }
    setVideoPlaying(ref.current.paused);
  };

  return (
    <div
      style={{
        top: top - 400,
        left: left - 225,
      }}
      className={classes.popup}
    >
      <div className={classes.container}>
        <video
          autoPlay
          className={classes.video}
          ref={ref}
          onClick={evt => {
            evt.stopPropagation();
            toggleVideoPlaying();
          }}
        >
          <source src="https://theatro360-manual-assets.s3-us-west-2.amazonaws.com/kbvdj-mnk9f_1.webm" />
        </video>
        <div
          className={classes.cardsContainer}
          onClick={evt => evt.stopPropagation()}
        >
          <div>
            <div className={classes.close} onClick={closePopup}>
              <span>+</span>
            </div>
          </div>
          <div>
            <div className={classes.title}>ED DICKINSON</div>
            <div className={classes.description}>CELL: +33 6 48 90 59 13</div>
            <div
              className={classes.contactAgent}
              onClick={() => {
                window.location.href =
                  "https://www.northropandjohnson.com/brokers/ed-dickinson";
              }}
            >
              Contact Broker
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VPRPopup;
